// extracted by mini-css-extract-plugin
export default {"graph":"PricingGraph_graph__PGatA"};